import { useAppSelector } from "store/hooks";
import { companyData } from "store/selectors";
import { ConditionalRenderer } from "components";
import { licenseValidityStatus } from "utils/constants";

const { invalid, valid } = licenseValidityStatus;

export function LicenseExpiryWarning() {
  const { company } = useAppSelector(companyData);

  function warningText(days: any) {
    if (days === -2) {
      return (
        <>
          Your license expired
          <span className="font-bold"> {Math.abs(days)}</span> days ago. The
          server will stop working today. Please contact support team to renew
          license immediately to avoid any interruption.
        </>
      );
    }
    if (days === -1) {
      return (
        <>
          Your license expired
          <span className="font-bold"> {Math.abs(days)}</span> day ago. The
          server will stop working tomorrow. Please contact support team to
          renew license immediately to avoid any interruption.
        </>
      );
    }
    if (days === 0) {
      return "Your license has expired today. Please contact support team to renew license immediately to avoid any interruption.";
    }
    if (days > 0) {
      return (
        <>
          Your license is expiring in <span className="font-bold">{days}</span>
          {days > 1 ? " days" : " day"}. Please contact support team to renew
          license.
        </>
      );
    }
  }

  const licenceWarningCondition =
    company?.license_validity_status &&
    company?.license_validity_status !== valid &&
    company?.license_validity_status !== invalid;

  return (
    <ConditionalRenderer condition={licenceWarningCondition}>
      <div className="bg-amber-50 border-l-4 border-amber-500 p-2 mx-auto">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg
              className="h-8 w-8 text-amber-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-lg font-semibold text-amber-600 font-mono">
              {warningText(parseInt(company?.license_validity_status))}
            </p>
          </div>
        </div>
      </div>
    </ConditionalRenderer>
  );
}
